import * as React from 'react';
import { useAnimate } from '@mui/x-charts/hooks';
import { ChartContainer } from '@mui/x-charts/ChartContainer';
import { BarPlot } from '@mui/x-charts/BarChart';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { styled } from '@mui/material/styles';
import { interpolateObject } from '@mui/x-charts-vendor/d3-interpolate';
import { useVendasStore } from '../store/VendasStore';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

export default function LabelsAboveBars() {
    const {
        qtd_de_uso_do_pix,
        qtd_de_uso_do_debito,
        qtd_de_uso_do_credito,
        mostrar_grafico_meios_mais_usados,
        somatorio_do_meios_de_pagamentos
    } = useVendasStore();

    if (mostrar_grafico_meios_mais_usados && somatorio_do_meios_de_pagamentos  > 0) {
        return (
            <>
                <Box>
                    <Typography variant="h4" component="p">
                       Pagamentos feitos: {somatorio_do_meios_de_pagamentos}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        * Dados referentes ao mês corrente.
                    </Typography>
                </Box>

                <ChartContainer
                    xAxis={[{ scaleType: 'band', data: ['PIX', 'CRÉDITO', 'DÉBITO'] }]}
                    series={[{ type: 'bar', id: 'base', data: [qtd_de_uso_do_pix, qtd_de_uso_do_debito, qtd_de_uso_do_credito] }]}
                    height={200}
                    yAxis={[{ width: 30 }]}
                    margin={{ left: 0, right: 10 }}
                >
                    <BarPlot barLabel="value" slots={{ barLabel: BarLabel }} />
                    <ChartsXAxis />
                    <ChartsYAxis />
                </ChartContainer>
            </>
        );
    }

    return (
        <Card
            variant="outlined"
            sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
        >
            <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                * Para ver o meios pagamentos mais utilizados no mês faça uma venda.
            </Typography>
        </Card>
    );
}

const Text = styled('text')(({ theme }) => ({
    ...theme?.typography?.body2,
    stroke: 'none',
    fill: (theme.vars || theme)?.palette?.text?.primary,
    transition: 'opacity 0.2s ease-in, fill 0.2s ease-in',
    textAnchor: 'middle',
    dominantBaseline: 'central',
    pointerEvents: 'none',
}));

function BarLabel(props) {
    const {
        seriesId,
        dataIndex,
        color,
        isFaded,
        isHighlighted,
        classes,
        xOrigin,
        yOrigin,
        x,
        y,
        width,
        height,
        layout,
        skipAnimation,
        ...otherProps
    } = props;

    const animatedProps = useAnimate(
        { x: x + width / 2, y: y - 8 },
        {
            initialProps: { x: x + width / 2, y: yOrigin },
            createInterpolator: interpolateObject,
            transformProps: (p) => p,
            applyProps: (element, p) => {
                element.setAttribute('x', p.x.toString());
                element.setAttribute('y', p.y.toString());
            },
            skip: skipAnimation,
        },
    );

    return (
        <Text {...otherProps} fill={color} textAnchor="middle" {...animatedProps} />
    );
}
